import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.91675 5.83333C2.91675 3.99238 4.40913 2.5 6.25008 2.5C8.09103 2.5 9.58342 3.99238 9.58342 5.83333C9.58342 7.67428 8.09103 9.16667 6.25008 9.16667C4.40913 9.16667 2.91675 7.67428 2.91675 5.83333Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.4167 5.83333C10.4167 3.99238 11.9091 2.5 13.7501 2.5C15.591 2.5 17.0834 3.99238 17.0834 5.83333C17.0834 7.67428 15.591 9.16667 13.7501 9.16667C11.9091 9.16667 10.4167 7.67428 10.4167 5.83333Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.24987 10C8.64218 10 10.9114 11.6505 11.756 14.6779C12.1976 16.2609 10.8475 17.5 9.46158 17.5H3.03815C1.65219 17.5 0.302095 16.2609 0.743709 14.6779C1.5883 11.6505 3.85755 10 6.24987 10Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.362 14.2301C12.9555 12.773 12.2567 11.5405 11.3583 10.5851C12.1046 10.1988 12.9201 10 13.7505 10C16.1428 10 18.412 11.6505 19.2566 14.6779C19.6982 16.2609 18.3481 17.5 16.9622 17.5H12.7757C13.4157 16.6291 13.708 15.4701 13.362 14.2301Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }